'use client';

import { forwardRef } from 'react';

import { ButtonProps, Button } from '@nextui-org/react';
import { signIn } from 'next-auth/react';

import { useSession } from '@/shared/hooks/use-session';

export const LoginBtn = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ onClick, ...props }, ref) => {
    const { user, isPending } = useSession();
    const onClickHandler = (e: any) => {
      onClick?.(e);
      signIn();
    };
    if (user || isPending) {
      return null;
    }
    return (
      <Button color="primary" ref={ref} {...props} onClick={onClickHandler}>
        Войти
      </Button>
    );
  },
);

LoginBtn.displayName = 'LoginBtn';
